import { AUTOTRADE_STRATEGY_OPTIONS } from './autotradeStrategies';

/** Default per-strategy exit settings (keep in sync with backend auto_trade_strategy_exit.py). */
export const DEFAULT_STRATEGY_EXIT_CONFIG = Object.fromEntries(
  AUTOTRADE_STRATEGY_OPTIONS.map((opt) => {
    if (opt.value === 'ma_ribbon_cloud_atr') {
      return [opt.value, { target_points: 30, stop_loss_points: 15, trailing_enabled: true }];
    }
    if (opt.value === 'zone_reversal') {
      return [opt.value, { target_points: 10, stop_loss_points: 10, trailing_enabled: true }];
    }
    return [opt.value, { target_points: 10, stop_loss_points: 10, trailing_enabled: false }];
  }),
);

export function mergeStrategyExitConfig(serverConfig) {
  const merged = { ...DEFAULT_STRATEGY_EXIT_CONFIG };
  if (!serverConfig || typeof serverConfig !== 'object') {
    return merged;
  }
  for (const [key, val] of Object.entries(serverConfig)) {
    const k = String(key).toLowerCase();
    if (!merged[k] || !val || typeof val !== 'object') continue;
    merged[k] = {
      target_points: Number(val.target_points) || merged[k].target_points,
      stop_loss_points: Number(val.stop_loss_points) || merged[k].stop_loss_points,
      trailing_enabled: Boolean(val.trailing_enabled),
    };
  }
  return merged;
}
